import React, { useEffect, useState, useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import styles from './outComeRegister.module.scss';
import  { ApiCore } from '../../../api/index';
import utils from '../../../utils/utils';
import CRFComponent from '../../../component/crf/crf';
import { Toast } from 'antd-mobile';
const api = new ApiCore();

let submitFlag = true;

function OutComeRegister(props: any) {

    const [formData, setFormData] = useState<any>({});

    const CrfRef: any = useRef();
    const history: any = useHistory();

    useEffect(() => {
        initData();
        return () => {
            submitFlag = true;
        }
    }, [])

    const initData = () => {
        const formData = sessionStorage.getItem('OutComeRegisterData');
        if (formData) {
            let _formData: any = {};
            try {
                _formData = JSON.parse(formData);
            } catch (error) {
                _formData = {};
            }
            setFormData(_formData);
        }
    }

    /**
     * 保存表单内容
     */
     const handleSave = () => {
        CrfRef.current.handleSave()
    }

  /**
    * 表单内容保存成功的回调
    * @param savedData 
    */
    const onSaveSuccess = (savedData: any) => {
        if (submitFlag) {
            api.toCaseTransferFileRegister({
                caseCode: formData.caseCode
            }).then((res: any) => {
                if (res.code == 0) {
                    submitFlag = false;
                    Toast.success('保存成功');
                    history.goBack()
                } else {
                    submitFlag = true;
                    Toast.info(res.message || '保存失败');
                }
            });
        }
        submitFlag = false;
    }

    return (
        <div className={`${styles.outComeRegister_content} ${props.inPrePage ? styles.noFullScreen : styles.fullScreen}`}>
            <div className={styles.crfContent}>
            {
                formData && Object.keys(formData).length > 0 &&
                <CRFComponent
                    ref={CrfRef}
                    params={formData}
                    onSaveSuccess={(v: any) => onSaveSuccess(v)}
                />
            }
            </div>
            <div className={styles.actonBtns}>
                <div className={styles.backBtn} onClick={() => history.goBack()}>返回</div>
                <div className={styles.nextBtn} onClick={handleSave}>
                    保存
                </div>
            </div>
        </div>
    )

}

export default withRouter(OutComeRegister);